import React from 'react';
import { formatApiDate } from '../utils/security';
import CihazDegisimiOnaylaModal from './CihazDegisimiOnaylaModal';
import './CihazDegisimiDetayModal.css';

const CihazDegisimiDetayModal = ({ cihazDegisimi, onClose, onRefresh, isAdmin }) => {
  const [onayModalOpen, setOnayModalOpen] = React.useState(false);

  if (!cihazDegisimi) return null;

  const data = cihazDegisimi.veri || cihazDegisimi;
  const durum = data.durum || '';

  const handleOnaySuccess = () => {
    setOnayModalOpen(false);
    onRefresh?.();
    onClose();
  };

  return (
    <div className="modal-overlay cihaz-degisimi-detay-modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className="fas fa-exchange-alt" style={{ marginRight: '8px' }}></i>
            Cihaz Değişimi Detayı — {data.cihazDegisimiNumarasi || '—'}
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="cihaz-degisimi-detay-grid">
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Cihaz Değişim No</span>
              <span className="value highlight">{data.cihazDegisimiNumarasi || '—'}</span>
            </div>
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Randevu No</span>
              <span className="value">{data.randevuNumarasi || '—'}</span>
            </div>
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Randevu Tarihi / Saati</span>
              <span className="value">{formatApiDate(data.randevuTarihi)} {data.randevuSaati || ''}</span>
            </div>
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Cihaz (Seri No)</span>
              <span className="value">{data.seriNumarasi || '—'}</span>
            </div>
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Ürün Adı</span>
              <span className="value">{data.urunAdi || '—'}</span>
            </div>
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Teknik Servis</span>
              <span className="value">{data.teknikServisAdi || '—'}</span>
            </div>
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Durum</span>
              <span className={`value status-badge ${
                durum === 'OnayBekliyor' ? 'status-bekliyor' :
                durum === 'Onaylandi' ? 'status-tamamlandi' :
                durum === 'IptalEdildi' ? 'status-iptal' : ''
              }`}>
                {durum === 'OnayBekliyor' ? 'Onay Bekliyor' : durum === 'Onaylandi' ? 'Onaylandı' : durum === 'IptalEdildi' ? 'İptal Edildi' : durum}
              </span>
            </div>
            {data.iadeKargoNumarasi && (
              <div className="cihaz-degisimi-detay-field">
                <span className="label">İade Kargo No</span>
                <span className="value">{data.iadeKargoNumarasi}</span>
              </div>
            )}
            <div className="cihaz-degisimi-detay-field">
              <span className="label">Oluşturma Tarihi</span>
              <span className="value">{formatApiDate(data.olusturmaTarihi)}</span>
            </div>
          </div>

          <div className="modal-actions">
            {isAdmin && durum === 'OnayBekliyor' && (
              <button type="button" className="btn btn-primary" onClick={() => setOnayModalOpen(true)}>
                <i className="fas fa-check" style={{ marginRight: '8px' }}></i>
                Onayla / İptal
              </button>
            )}
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Kapat
            </button>
          </div>
        </div>
      </div>

      {onayModalOpen && (
        <CihazDegisimiOnaylaModal
          cihazDegisimi={data}
          onClose={() => setOnayModalOpen(false)}
          onSuccess={handleOnaySuccess}
        />
      )}
    </div>
  );
};

export default CihazDegisimiDetayModal;
